<script>
import { mapActions } from 'vuex'
import TermoContainer from '../components/termo-container/termo-container.vue'

export default {

  components: {
    TermoContainer
  },

  data () {
    return {
      textoPolitica: ''
    }
  },

  async created () {
    this.getTextoPolitica()
  },

  methods: {
    ...mapActions({
      getPoliticaDePrivacidade: 'usuario/getPoliticaDePrivacidade'
    }),
    async getTextoPolitica () {
      this.textoPolitica = await this.getPoliticaDePrivacidade()
    }
  }
}
</script>

<template>
  <termo-container
    v-if="textoPolitica"
    :texto="textoPolitica"
  />
</template>



// WEBPACK FOOTER //
// src/App/(authenticated)/termos/politica-de-privacidade/politica-de-privacidade.vue